import React from "react";
import "../../global.scss";

interface TextProps {
  placetext: string;
  value: string;
  setValue: any;
  type: any;
  maxlength: any;
  checkCondition: any;
  style: any;
  readOnly?: boolean;
}

export const AddressTextField: React.FC<TextProps> = ({
  placetext,
  value,
  setValue,
  type,
  maxlength,
  checkCondition,
  style,
  readOnly = false,
}: TextProps) => {
  return (
    <input
      readOnly={readOnly}
      style={{
        cursor: readOnly ? "no-drop" : "default",
        backgroundColor: readOnly ? "#dddddd" : "",
      }}
      type={type}
      className={!!style ? style : "add_field_margin"}
      placeholder={placetext}
      value={value}
      maxLength={maxlength}
      onChange={(e: any) => {
        if (checkCondition) {
          return /^\D+$/.test(e.target.value) || !e.target.value
            ? setValue(e.target.value.trim().length ? e.target.value : "")
            : null;
        } else {
          setValue(e.target.value.trim().length ? e.target.value : "");
        }
      }}
    />
  );
};
